import * as React from "react";

export default function usePrefersColorScheme(): "light" | "dark" | undefined {
  const [getSnapshot, getServerSnapshot, subscribe] = React.useMemo(() => {
    const matchMedia = () => window.matchMedia("(prefers-color-scheme: dark)");

    return [
      () => (matchMedia().matches ? "dark" : "light"),
      () => undefined,
      (notify: () => void) => {
        matchMedia().addEventListener("change", notify);
        return () => {
          matchMedia().removeEventListener("change", notify);
        };
      },
    ];
  }, []);

  return React.useSyncExternalStore(
    subscribe,
    typeof window !== "undefined" ? getSnapshot : getServerSnapshot,
    getServerSnapshot,
  );
}
